// Sprint 20.3 PR-7 (D013-EC-22) — founder-mode pill rendered when the
// per-agent live-stream backpressure cap (10 MB) was hit during the
// current turn. The DB has the full message; only the live stream is
// degraded. Reloading the chat fetches the persisted version.
//
// Founder copy: "[truncated · reload to refetch]" — flat, plain
// language, links to the existing reload affordance.

import { t } from '../i18n';
import { useAppStore } from '../stores/app.store';

export interface StreamTruncatedPillProps {
  agentId: string;
}

export function StreamTruncatedPill({ agentId }: StreamTruncatedPillProps) {
  const truncated = useAppStore((s) => Boolean(s.streamTruncatedByAgent[agentId]));
  const loadMessages = useAppStore((s) => s.loadMessages);
  if (!truncated) return null;
  return (
    <button
      type="button"
      onClick={() => {
        void loadMessages(agentId);
      }}
      data-testid="stream-truncated-pill"
      className="inline-flex items-center gap-1 rounded-md border border-dashed border-border bg-background/40 px-2 py-1 text-xs text-muted-foreground hover:text-foreground"
      aria-label={t('streamTruncated.ariaLabel')}
    >
      <span aria-hidden="true">{t('streamTruncated.icon')}</span>
      <span>{t('streamTruncated.label')}</span>
    </button>
  );
}
